import type { FeatureEntity, SupportedFeature } from "@src/gql/graphql";

export const planQueryKeys = {
	myPlan: (shareKey?: string) => ["myPlan", shareKey ?? null],
	allMyPlanEntityMetered: ["myPlan", "entityMetered"],
	myPlanEntityMetered: (
		entityId: string,
		entityType: FeatureEntity,
		supportedFeature: SupportedFeature,
	) => [
		...planQueryKeys.allMyPlanEntityMetered,
		entityId,
		entityType,
		supportedFeature,
	],
};
